<template>
  <div class="ChartsFontStyleConfiger">
    <div class="p-name">图表文字样式</div>
    <div class="charts-style-config" v-if="fonstyle.titleSize !== undefined">
      <span>标题大小</span>
      <div>
        <el-input @blur="handleChange" size="mini" v-model="fonstyle.titleSize" placeholder=""></el-input>px
      </div>
      <span>标题颜色</span>
      <el-color-picker
        size="mini"
        @change="handleTitleColorChange"
        show-alpha
        v-model="fonstyle.titleColor"
      ></el-color-picker>
    </div>
    <div class="charts-style-config" v-if="fonstyle.xAxisSize !== undefined">
      <span>X轴大小</span>
      <div>
        <el-input @blur="handleChange" size="mini" v-model="fonstyle.xAxisSize" placeholder=""></el-input>px
      </div>
      <span>X轴颜色</span>
      <el-color-picker
        size="mini"
        @change="handlexAxisColorChange"
        show-alpha
        v-model="fonstyle.xAxisColor"
      ></el-color-picker>
    </div>
    <div class="charts-style-config" v-if="fonstyle.yAxisSize !== undefined">
      <span>Y轴大小</span>
      <div>
        <el-input @blur="handleChange" size="mini" v-model="fonstyle.yAxisSize" placeholder=""></el-input>px
      </div>
      <span>Y轴颜色</span>
      <el-color-picker
        size="mini"
        @change="handleyAxisColorChange"
        show-alpha
        v-model="fonstyle.yAxisColor"
      ></el-color-picker>
    </div>
    <div class="charts-style-config" v-if="fonstyle.innerTitleSize !== undefined">
      <span>内部标题大小</span>
      <div>
        <el-input @blur="handleChange" size="mini" v-model="fonstyle.innerTitleSize" placeholder=""></el-input>px
      </div>
      <span>内部标题颜色</span>
      <el-color-picker
        size="mini"
        @change="handleyAxisColorChange"
        show-alpha
        v-model="fonstyle.innerTitleColor"
      ></el-color-picker>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ChartsFontStyleConfiger',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      fonstyle: {},
    };
  },
  created() {
    this.fonstyle = this.$_.cloneDeep(this.propertyData[this.propertyDataKey].value);
  },
  mounted() {
    /* 获取初始值 */
  },
  methods: {
    commitCurrentPropertyData(val) {
      console.log(val, '---------fonstyle-----------');
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
    initCurrentPropertyData() {
      this.fonstyle = this.$_.cloneDeep(this.propertyData[this.propertyDataKey].value);
    },
    handleTitleColorChange(color) {
      console.log(color);
      if (color) this.commitCurrentPropertyData(this.fonstyle);
    },
    handlexAxisColorChange(color) {
      console.log(color);
      if (color) this.commitCurrentPropertyData(this.fonstyle);
    },
    handleyAxisColorChange(color) {
      console.log(color);
      if (color) this.commitCurrentPropertyData(this.fonstyle);
    },
    handleChange() {
      let allowCommit = true;
      // this.fonstyle.title = this.fonstyle.title

      for (let key in this.fonstyle) {
        if (this.fonstyle[key] == '0') {
          allowCommit = false;
        }
      }

      if (allowCommit) {
        this.commitCurrentPropertyData(this.fonstyle);
      } else {
        this.$ElMessage.error('设置数值非法！');
        this.fonstyle = this.$_.cloneDeep(this.propertyData[this.propertyDataKey].value);
      }
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ChartsFontStyleConfiger {
  width: 100%;
  box-sizing: border-box;
  .p-name {
    color: $property-title-color;
    font-size: $property-title-size;
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    line-height: 30px;
  }
  .charts-style-config {
    margin: 5px 0;
    color: $property-attributes-color;
    font-size: $property-attributes-size;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 30px;

    .el-input {
      width: 35px;
      margin-right: 5px;
    }
    span {
      width: 60px;
      box-sizing: border-box;
      padding-left: 5px;
    }

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);
      padding-left: 2px;
      padding-right: 2px;
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
</style>
